import React from "react";
import { Container, Typography, Button, Paper, Box } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Lottie from "lottie-react";

const OrderConfirmed = ({ orderId }) => {
  return (
    <Container maxWidth="sm" sx={{ textAlign: "center", marginTop : '10%' }}>
      <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
        <Box display="flex" justifyContent="center">
        <CheckCircleIcon color="success" sx={{ fontSize: 80 }} />
        </Box>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Order Confirmed! 🎉
        </Typography>
        <Typography variant="body1" color="text.secondary" gutterBottom>
          Thank you for your purchase! Your order has been successfully placed.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          You will receive an email confirmation shortly with the details of your order.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="large"
          sx={{ mt: 3, borderRadius: 2 }}
          href="/shop"
        >
          Explore More
        </Button>
      </Paper>
    </Container>
  );
};

export default OrderConfirmed;
